import { render, staticRenderFns } from "./copergelenfatura.vue?vue&type=template&id=5adfe0e4&scoped=true&"
import script from "./copergelenfatura.vue?vue&type=script&lang=js&"
export * from "./copergelenfatura.vue?vue&type=script&lang=js&"
import style0 from "./copergelenfatura.vue?vue&type=style&index=0&id=5adfe0e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adfe0e4",
  null
  
)

export default component.exports